export enum IconFilterOptions {
  ONLY_ACTORS = 'ICON_FILTER_ACTOR',
  ONLY_WORKOBJECTS = 'ICON_FILTER_WORKOBJECT',
  ONLY_UNASSIGNED = 'ICON_FILTER_UNASSIGNED',
  NO_FILTER = '',
}
